import * as React from "react";
import { Link } from "react-router-dom";
import actionTypes from "../../../../actions/ActionTypes";
import IntakeStrategySidebar from "./IntakeStrategySidebar";
import { createBrowserHistory } from "history";
import {
  LoadIntakeStrategies,
  LoadIntakeStrategy,
  UpdateIntakeStrategy,
  DeleteIntakeStrategy
} from "../../../../actions/ISActions";
import { GetBPList } from "../../../../actions/BPActions";
import { GetTemplateList } from "../../../../actions/TemplateActions";
import { LoadReaders } from "../../../../actions/ReadersActions";
import ISStore from "../../../../stores/IntakeStrategyStore";
import InboxStore from "../../../../stores/InboxStore";
import TemplateStore from "../../../../stores/TemplateStore";
import BPStore from "../../../../stores/BPStore";
import ReaderStore from "../../../../stores/ReadersStore";
import { IntakeStrategyTarget } from "../../../../models/admin/IntakeStrategy";
const customHistory = createBrowserHistory();
class BPSelection {
  selectionId;
  display;
  typeId;
  bpId;
  wfId;
  ftpId;
  ftId;
  workflow;
  formType;
}
class IntakeStrategyView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIS: void 0,
      showEditName: false,
      editName: "",
      showBCDialog: false,
      showBCAdder: false,
      //barcodes: [],
      selectedBarcode: "",
      editBarcodes: [],
      legacyBPs: [],
      bpSelections: [],
      allTemplates: [],
      filteredTemplates: [],
      selectedBPId: 0,
      selectedTemplateId: 0,
      isDirty: false,
      isRearranging: false,
      templateError: "",
      deleteStatus: 0,
      newBarcodeFormula: "",
      doesIronServiceExist: false,
      doesOcrServiceExist: false,
      allReaders: []
    };
    this.onISChange = this.onISChange.bind(this);
    this.checkForUpdate = this.checkForUpdate.bind(this);
    this.isNameChangeClick = this.isNameChangeClick.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleNameSaveClick = this.handleNameSaveClick.bind(this);
    this.handleNameCancelClick = this.handleNameCancelClick.bind(this);
    this.ocrRadioChange = this.ocrRadioChange.bind(this);
    this.onFastPassChange = this.onFastPassChange.bind(this);
    this.onReadBarcodeChange = this.onReadBarcodeChange.bind(this);
    this.onEnablePreSplitChange = this.onEnablePreSplitChange.bind(this);
    this.onEnableBarcodeSplitChange = this.onEnableBarcodeSplitChange.bind(this);
    this.hideBCDialog = this.hideBCDialog.bind(this);
    this.openBCAdder = this.openBCAdder.bind(this);
    this.hideBCAdder = this.hideBCAdder.bind(this);
    this.handleBCSelectionChange = this.handleBCSelectionChange.bind(this);
    this.handleAddBarcode = this.handleAddBarcode.bind(this);
    this.onEditBarcode = this.onEditBarcode.bind(this);
    this.onDeleteBCRow = this.onDeleteBCRow.bind(this);
    this.onAddFormula = this.onAddFormula.bind(this);
    this.onCancelBarcodes = this.onCancelBarcodes.bind(this);
    this.onTemplateStrategyChange = this.onTemplateStrategyChange.bind(this);
    this.onLegacyBPChange = this.onLegacyBPChange.bind(this);
    this.onTemplateChange = this.onTemplateChange.bind(this);
    this.handleBPSelection = this.handleBPSelection.bind(this);
    this.onOCRQualityChange = this.onOCRQualityChange.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.onAddTarget = this.onAddTarget.bind(this);
    this.handleSelectTarget = this.handleSelectTarget.bind(this);
    this.onTargetOk = this.onTargetOk.bind(this);
    this.onTargetEdit = this.onTargetEdit.bind(this);
    this.onTargetDel = this.onTargetDel.bind(this);
    this.onRearrangeClick = this.onRearrangeClick.bind(this);
    this.onMoveTargetDown = this.onMoveTargetDown.bind(this);
    this.onMoveTargetUp = this.onMoveTargetUp.bind(this);
    this.onChangeDupeDetection = this.onChangeDupeDetection.bind(this);
    this.handleTemplateSelection = this.handleTemplateSelection.bind(this);
    this.updateTemplateFilter = this.updateTemplateFilter.bind(this);
    this.handleDeleteBarcode = this.handleDeleteBarcode.bind(this);
    this.deleteIntakeStrategy = this.deleteIntakeStrategy.bind(this);
    this.startDelete = this.startDelete.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.selectTargetTemplate = this.selectTargetTemplate.bind(this);
    this.handleBarcodeEdit = this.handleBarcodeEdit.bind(this);
    this.onPreFlattenChange = this.onPreFlattenChange.bind(this);
    this.updateUseAIReader = this.updateUseAIReader.bind(this);
    this.onReadersChange = this.onReadersChange.bind(this);
    this.handleAutoReaderChange = this.handleAutoReaderChange.bind(this);
    this.updateUseDefaults = this.updateUseDefaults.bind(this);
    this.onInboxChange = this.onInboxChange.bind(this);
  }
  componentDidMount() {
    InboxStore.addChangeListener(this.onInboxChange);
    ISStore.addChangeListener(this.onISChange);
    BPStore.addChangeListener(this.onLegacyBPChange);
    TemplateStore.addChangeListener(this.onTemplateChange);
    ReaderStore.addChangeListener(this.onReadersChange);
    LoadIntakeStrategies();
    this.updateIS();
    document.title = "TrinDocs - Intake Strategies";
  }
  componentWillUnmount() {
    InboxStore.removeChangeListener(this.onInboxChange);
    ISStore.removeChangeListener(this.onISChange);
    BPStore.removeChangeListener(this.onLegacyBPChange);
    TemplateStore.removeChangeListener(this.onTemplateChange);
    ReaderStore.removeChangeListener(this.onReadersChange);
  }
  componentDidUpdate() {
    this.checkForUpdate();
  }
  onISChange() {
    let iStrategy = ISStore.getCurrentIS();
    let lastAction = ISStore.getLastAction();
    if (lastAction === actionTypes.IntakeStrategyDelete) {
      let link = document.getElementById("intakeStrategyHomeLink");
      link.click();
    } else if (iStrategy !== void 0) {
      let ironOcrValid = ISStore.getIronService();
      let ocrValid = ISStore.getOcrService();
      this.setState(
        {
          currentIS: iStrategy,
          selectedBPId: iStrategy.bpId,
          isDirty: false,
          doesIronServiceExist: ironOcrValid,
          doesOcrServiceExist: ocrValid
        },
        this.updateTemplateFilter()
      );
    }
  }
  onInboxChange() {
    var lastChange = InboxStore.lastChange();
    if (lastChange === actionTypes.GetHeaderFieldsByFormType) {
      var fields = InboxStore.getHeaderFields();
      this.setState({ fields });
    }
  }
  checkForUpdate() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let isId = parseInt(pathParts[pathParts.length - 1], 10);
    if (isId !== 0 && this.state.currentIS !== void 0 && this.state.currentIS.id !== isId) {
      this.updateIS();
    }
  }
  // onBCChange() {
  //    let newBarcodes = BarcodeStore.getBarcodes();
  //    this.setState({ barcodes: newBarcodes });
  // }
  onLegacyBPChange() {
    let legacy = BPStore.getBPList();
    this.setState({ legacyBPs: legacy });
    let selections = [];
    let def = new BPSelection();
    def.selectionId = 0;
    def.display = "Select a business process";
    def.bpId = 0;
    def.ftpId = 0;
    def.typeId = -1;
    selections.push(def);
    let nextId = 1;
    legacy.forEach((ftp) => {
      let s = new BPSelection();
      s.selectionId = nextId;
      s.display = ftp.bpName;
      s.bpId = ftp.bpId;
      s.typeId = 0;
      s.wfId = ftp.workflowId;
      s.workflow = "";
      s.formType = ftp.formTypeName;
      s.ftId = ftp.formTypeId;
      selections.push(s);
      nextId++;
    });
    this.setState({ bpSelections: selections }, this.updateTemplateFilter);
  }
  onTemplateChange() {
    let templates = [];
    let templateGroups = TemplateStore.getTemplateList();
    if (templateGroups !== null && templateGroups !== void 0) {
      templateGroups.forEach((tg) => {
        tg.templates.forEach((t) => {
          templates.push(t);
        });
      });
      this.setState({ allTemplates: templates }, () => {
        if (this.state.currentIS !== null) {
          this.updateTemplateFilter();
        }
      });
    }
  }
  onReadersChange() {
    let lastAction = ReaderStore.getLastAction();
    if (lastAction === actionTypes.GetReaders) {
      let readerList = ReaderStore.getReaders();
      this.setState({ allReaders: readerList });
    }
  }
  updateIS() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let isId = parseInt(pathParts[pathParts.length - 1], 10);
    LoadIntakeStrategy(isId);
    GetBPList();
    GetTemplateList();
    LoadReaders();
  }
  handleNameSaveClick() {
    let newIs = this.state.currentIS;
    newIs.isName = this.state.editName;
    this.setState({ currentIS: newIs });
    this.setState({ showEditName: false, isDirty: true });
  }
  ocrRadioChange(id) {
    let newIS = this.state.currentIS;
    newIS.ocrMethod = id;
    console.log(newIS);
    this.setState({ currentIS: newIS, isDirty: true });
  }
  onFastPassChange(e) {
    let newIS = this.state.currentIS;
    newIS.useFastPass = e.target.checked;
    this.setState({ currentIS: newIS, isDirty: true });
  }
  onReadBarcodeChange(e) {
    let newIS = this.state.currentIS;
    newIS.readBarcode = e.target.checked;
    newIS.enableBarcodeSplit = false;
    newIS.enablePreSplit = false;
    this.setState({ currentIS: newIS, isDirty: true });
  }
  onChangeDupeDetection(e) {
    let newIS = this.state.currentIS;
    newIS.dupeDetection = e.target.value;
    this.setState({ currentIS: newIS, isDirty: true });
  }
  onEnablePreSplitChange(e) {
    if (this.state.currentIS.readBarcode === true) {
      let newIS = this.state.currentIS;
      newIS.enablePreSplit = e.target.checked;
      this.setState({ currentIS: newIS });
    }
  }
  onEnableBarcodeSplitChange(e) {
    if (this.state.currentIS.readBarcode === true) {
      let newIS = this.state.currentIS;
      newIS.enableBarcodeSplit = e.target.checked;
      this.setState({ currentIS: newIS });
    }
  }
  handleNameCancelClick() {
    this.setState({ showEditName: false });
  }
  handleNameChange(event) {
    this.setState({ editName: event.target.value });
  }
  isNameChangeClick() {
    let currentName = this.state.currentIS.isName;
    this.setState({ showEditName: true, editName: currentName });
  }
  // openBCDialog() {
  //    let newEdits = [];
  //    this.state.barcodes.forEach((bc) => {
  //       let bcEdit: BarcodeEdit = {
  //          id: bc.barcodeId,
  //          formula: bc.formula,
  //          name: bc.name,
  //          isNew: false,
  //          isDirty: false,
  //          isDeleted: false,
  //       };
  //       newEdits.push(bcEdit);
  //    });
  //    this.setState({ editBarcodes: newEdits });
  //    this.setState({ showBCDialog: true });
  // }
  hideBCDialog() {
    this.setState({ showBCDialog: false });
  }
  openBCAdder() {
    this.setState({ selectedBarcode: "", showBCAdder: true });
  }
  hideBCAdder() {
    this.setState({ showBCAdder: false });
  }
  handleBCSelectionChange(e) {
    this.setState({ selectedBarcode: e.target.value });
  }
  handleTemplateSelection(e) {
    let updateIS = this.state.currentIS;
    updateIS.templateId = parseInt(e.target.value, 10);
    this.setState({ currentIS: updateIS, isDirty: true });
  }
  updateTemplateFilter() {
    if (this.state.currentIS !== void 0) {
      let filter = [];
      let bpId = this.state.currentIS.bpId;
      let ftp = this.state.legacyBPs.find((f) => f.bpId === bpId);
      if (ftp !== void 0) {
        this.state.allTemplates.forEach((t) => {
          if (t.formTypeId === ftp.formTypeId) {
            let template = {
              templateId: t.templateId,
              name: t.name,
              formTypeId: t.formTypeId,
              isActive: true,
              isAutoOcr: t.isAutoOcr
            };
            filter.push(template);
          }
        });
        this.setState({ filteredTemplates: filter });
      }
    }
  }
  validateTemplates() {
    if (this.state.currentIS.templateStrategy === 1) {
      let bp = parseInt(this.state.selectedBPId.toString(), 10);
      if (bp === 0) {
        this.setState({
          templateError: "Please select a business process"
        });
        return false;
      }
      if (this.state.currentIS.templateId === 0 || this.state.currentIS.templateId === void 0) {
        this.setState({
          templateError: "Please select a template"
        });
        return false;
      }
    }
    if (this.state.currentIS.templateStrategy === 2) {
      console.log(this.state.currentIS.intakeTargets);
      if (this.state.currentIS.intakeTargets.length === 0) {
        this.setState({ templateError: "Must specify one or more Business Processes" });
        return false;
      } else {
        let hasBadTargets = false;
        this.state.currentIS.intakeTargets.forEach((t) => {
          if (t.bpId === 0) {
            hasBadTargets = true;
          }
        });
        if (hasBadTargets) {
          this.setState({ templateError: "Must specify one or more Business Processes" });
          return false;
        }
      }
    }
    this.setState({ templateError: "" });
    return true;
  }
  handleBPSelection(e) {
    this.setState({ selectedBPId: e.target.value });
    let updateIS = this.state.currentIS;
    let filter = [];
    updateIS.bpId = parseInt(e.target.value, 10);
    let selection = this.state.bpSelections.find(
      (b) => b.bpId === Number(e.target.value)
    );
    if (selection !== void 0 && selection.typeId === 0) {
      let ftp = this.state.legacyBPs.find((f) => f.bpId === selection.bpId);
      this.state.allTemplates.forEach((t) => {
        if (t.formTypeId === ftp.formTypeId) {
          let template = {
            templateId: t.templateId,
            name: t.name,
            formTypeId: t.formTypeId,
            isActive: true,
            isAutoOcr: t.isAutoOcr
          };
          filter.push(template);
        }
      });
    }
    this.setState({
      filteredTemplates: filter,
      selectedTemplateId: 0,
      currentIS: updateIS,
      isDirty: true
    });
  }
  handleAddBarcode() {
    let maxId = 1;
    let newIS = this.state.currentIS;
    if (newIS.barCodeSplits === null || newIS.barCodeSplits === void 0) {
      newIS.barCodeSplits = [];
    }
    newIS.barCodeSplits.forEach((bc) => {
      if (bc.barCodeId >= maxId) {
        maxId = bc.barCodeId + 1;
      }
    });
    newIS.barCodeSplits.push({
      barCodeId: maxId,
      barCodeFormula: this.state.newBarcodeFormula
    });
    this.setState({ newBarcodeFormula: "", currentIS: newIS });
  }
  handleDeleteBarcode(bcId) {
    let newIS = this.state.currentIS;
    let bcToRemove = newIS.barCodeSplits.find((f) => f.barCodeId === bcId);
    let bcIndex = newIS.barCodeSplits.indexOf(bcToRemove);
    newIS.barCodeSplits.splice(bcIndex, 1);
    this.setState({ currentIS: newIS });
  }
  // Barcode editor
  onEditBarcode(e) {
    let editBcs = this.state.editBarcodes;
    let parts = e.target.id.split("_");
    let idx = parseInt(parts[1], 10);
    let bcToEdit = editBcs.find((bc) => bc.id === idx);
    if (parts[0] === "bcInfoName") {
      bcToEdit.name = e.target.value;
      bcToEdit.isDirty = true;
    }
    if (parts[0] === "bcInfoFormula") {
      bcToEdit.formula = e.target.value;
      bcToEdit.isDirty = true;
    }
    this.setState({ editBarcodes: editBcs });
  }
  onDeleteBCRow(rowId) {
    let editBcs = this.state.editBarcodes;
    let bcToDelete = editBcs.find((bc) => bc.id === rowId);
    if (bcToDelete.isNew) {
      let idx = editBcs.indexOf(bcToDelete);
      editBcs.splice(idx, 1);
    } else {
      bcToDelete.isDeleted = true;
    }
    this.setState({ editBarcodes: editBcs });
  }
  onAddTarget() {
    let nextPriority = 1;
    this.state.currentIS.intakeTargets.forEach((t) => {
      if (t.priority >= nextPriority) {
        nextPriority = t.priority + 1;
      }
    });
    let newTarget = new IntakeStrategyTarget();
    newTarget.priority = nextPriority;
    newTarget.isEditing = true;
    newTarget.bpId = 0;
    newTarget.defaultBpId = 0;
    newTarget.defaultBpName = "";
    newTarget.bpName = "";
    newTarget.templates = [];
    let updatedIS = this.state.currentIS;
    updatedIS.intakeTargets.push(newTarget);
    this.setState({ currentIS: updatedIS, isDirty: true, templateError: "" });
  }
  handleSelectTarget(e, t) {
    let c = this.state.currentIS;
    let target = c.intakeTargets.find((tg) => tg.priority === t.priority);
    t.bpId = parseInt(e.target.value, 10);
    let bp = this.state.bpSelections.find(
      (x) => x.bpId === parseInt(e.target.value, 10)
    );
    if (bp !== void 0) {
      target.defaultBpId = bp.bpId;
      target.defaultBpName = bp.display;
      target.formTypeId = bp.ftId;
      target.workflowId = bp.wfId;
      target.template = void 0;
      target.defaultTemplateId = 0;
      target.defaultTemplateName = "None";
      target.templates = [];
      this.state.allTemplates.forEach((t2) => {
        if (t2.formTypeId === bp.ftId) {
          let template = {
            templateId: t2.templateId,
            name: t2.name,
            formTypeId: t2.formTypeId,
            isActive: true,
            isAutoOcr: t2.isAutoOCR
          };
          target.templates.push(template);
        }
      });
      this.setState({ currentIS: c });
    }
  }
  onTargetOk(t) {
    let c = this.state.currentIS;
    let target = c.intakeTargets.find((tg) => tg.priority === t.priority);
    target.isEditing = false;
    this.setState({ currentIS: c, isDirty: true });
  }
  onTargetEdit(t) {
    let c = this.state.currentIS;
    let target = c.intakeTargets.find((tg) => tg.priority === t.priority);
    target.isEditing = true;
    if (target.priority === 1) {
      target.templates = [];
      this.state.allTemplates.forEach((t2) => {
        if (t2.formTypeId === target.formTypeId) {
          let template = {
            templateId: t2.templateId,
            name: t2.name,
            formTypeId: t2.formTypeId,
            isActive: true,
            isAutoOcr: t2.isAutoOCR
          };
          target.templates.push(template);
        }
      });
    }
    this.setState({ currentIS: c, isDirty: false });
  }
  onTargetDel(t) {
    let c = this.state.currentIS;
    let target = c.intakeTargets.find((tg) => tg.priority === t.priority);
    let p = target.priority;
    let idx = c.intakeTargets.indexOf(target);
    c.intakeTargets.splice(idx, 1);
    c.intakeTargets.forEach((tg) => {
      if (tg.priority >= p) {
        tg.priority--;
      }
    });
    this.setState({ currentIS: c, isDirty: true });
  }
  onRearrangeClick() {
    if (this.state.isRearranging) {
      this.setState({ isRearranging: false });
    } else {
      this.setState({ isRearranging: true });
    }
  }
  onMoveTargetDown(t) {
    let c = this.state.currentIS;
    let target = c.intakeTargets.find((tg) => tg.priority === t.priority);
    let nextTarget = c.intakeTargets.find(
      (tg) => tg.priority === t.priority + 1
    );
    if (target !== void 0 && nextTarget !== void 0) {
      target.priority = target.priority + 1;
      nextTarget.priority = nextTarget.priority - 1;
    }
    c.intakeTargets.sort((a, b) => a.priority - b.priority);
    this.setState({ currentIS: c, isDirty: true });
  }
  onMoveTargetUp(t) {
    let c = this.state.currentIS;
    let target = c.intakeTargets.find((tg) => tg.priority === t.priority);
    let preTarget = c.intakeTargets.find(
      (tg) => tg.priority === t.priority - 1
    );
    if (target !== void 0 && preTarget !== void 0) {
      target.priority = target.priority - 1;
      preTarget.priority = preTarget.priority + 1;
    }
    c.intakeTargets.sort((a, b) => a.priority - b.priority);
    this.setState({ currentIS: c, isDirty: true });
  }
  onAddFormula() {
    let maxId = 0;
    this.state.editBarcodes.forEach((bc) => {
      if (bc.id > maxId) {
        maxId = bc.id;
      }
    });
    maxId++;
    let newEdits = this.state.editBarcodes;
    let newEdit = {
      id: maxId,
      formula: "",
      name: "",
      isNew: true,
      isDirty: false,
      isDeleted: false
    };
    newEdits.push(newEdit);
    this.setState({ editBarcodes: newEdits });
  }
  handleBarcodeEdit(e) {
    let formulaText = e.target.value;
    this.setState({ newBarcodeFormula: formulaText });
  }
  onCancelBarcodes() {
    this.setState({ showBCDialog: false });
  }
  onTemplateStrategyChange(templateStrategy) {
    let intake = this.state.currentIS;
    intake.templateStrategy = templateStrategy;
    if (templateStrategy === 1 || templateStrategy === 0) {
    }
    this.updateTemplateFilter();
    this.setState({ currentIS: intake, isDirty: true });
  }
  onPreFlattenChange(e) {
    let newIS = this.state.currentIS;
    newIS.flattenFields = e.target.checked;
    this.setState({ currentIS: newIS, isDirty: true });
  }
  onOCRQualityChange(e) {
    let currentIS = this.state.currentIS;
    currentIS.ocrQuality = parseInt(e.target.value, 0);
    this.setState({ currentIS, isDirty: true });
  }
  onSaveClick(e) {
    let intakeStrat = this.state.currentIS;
    intakeStrat.intakeTargets.forEach(function(tg) {
      tg.isEditing = false;
    });
    if (this.validateTemplates()) {
      console.log("save");
      UpdateIntakeStrategy(intakeStrat);
    }
  }
  startDelete() {
    this.setState({ deleteStatus: 1 });
  }
  deleteIntakeStrategy() {
    console.log("delete strategy");
    DeleteIntakeStrategy(this.state.currentIS);
    this.setState({ deleteStatus: 0 });
    customHistory.push("/Admin/IntakeStrategies");
  }
  cancelDelete() {
    this.setState({ deleteStatus: 0 });
  }
  selectTargetTemplate(e, target) {
    let currentIS = this.state.currentIS;
    let templates = target.templates;
    console.log(currentIS);
    console.log(e.target.value);
    console.log(templates);
    let update = currentIS.intakeTargets.find(
      (it) => it.priority === target.priority
    );
    let selectedTemplate = templates.find(
      (t) => t.templateId === parseInt(e.target.value, 10)
    );
    update.defaultTemplateId = selectedTemplate.templateId;
    update.defaultTemplateName = selectedTemplate.name;
    update.template = selectedTemplate;
    this.setState({ currentIS });
  }
  updateUseAIReader(e) {
    let cis = this.state.currentIS;
    cis.useAIOCR = e.target.checked;
    this.setState({ currentIS: cis, isDirty: true });
  }
  updateUseDefaults(e) {
    let cis = this.state.currentIS;
    cis.useDefaults = e.target.checked;
    this.setState({ currentIS: cis, isDirty: true });
  }
  handleAutoReaderChange(e) {
    console.log(e.target.value);
    let cis = this.state.currentIS;
    cis.autoReaderId = parseInt(e.target.value, 10);
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(IntakeStrategySidebar, { activePage: "is" }), this.state.currentIS !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: { backgroundColor: "#efefef", padding: "15px" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "5px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Intake Strategy"),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, this.state.showEditName !== true && /* @__PURE__ */ React.createElement("h3", { style: { fontSize: "14pt" } }, this.state.currentIS !== void 0 ? this.state.currentIS.isName : "", "    ", /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fa-solid fa-pen fas fa-pen ms-1",
            onClick: this.isNameChangeClick,
            style: {
              color: "#2D359B",
              cursor: "pointer"
            }
          }
        )), this.state.showEditName && /* @__PURE__ */ React.createElement("div", { className: "row g-3 align-items-center" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "isNameTxt", className: "col-form-label" }, "Intake Strategy Name:")), /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            id: "isNameTxt",
            className: "form-control",
            value: this.state.editName,
            onChange: this.handleNameChange
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            onClick: this.handleNameSaveClick
          },
          "OK"
        )), /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-secondary",
            onClick: this.handleNameCancelClick
          },
          "Cancel"
        ))))
      ),
      /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginRight: "10px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "OCR"),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            name: "flexRadioDefault",
            id: "ocrRadioNoOCR",
            onChange: (id) => this.ocrRadioChange(1),
            checked: this.state.currentIS.ocrMethod === 1
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "flexRadioDefault2"
          },
          "No OCR"
        )), /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            name: "flexRadioDefault",
            id: "ocrRadioTextOnly",
            onChange: () => this.ocrRadioChange(2),
            checked: this.state.currentIS.ocrMethod === 2
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "flexRadioDefault2"
          },
          "Text Only"
        )), this.state.doesOcrServiceExist && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            name: "flexRadioDefault",
            id: "ocrRadioSmartOCR",
            onChange: () => this.ocrRadioChange(4),
            checked: this.state.currentIS.ocrMethod === 3 || this.state.currentIS.ocrMethod === 4
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "flexRadioDefault2"
          },
          "OCR 1.0"
        )), (this.state.currentIS.ocrMethod === 3 || this.state.currentIS.ocrMethod === 4) && /* @__PURE__ */ React.createElement("span", { className: "" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch ms-3" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "checkbox",
            id: "fullOcr",
            onChange: () => this.ocrRadioChange(4),
            checked: this.state.currentIS.ocrMethod === 4
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "preSplitChange"
          },
          "Full"
        )), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch ms-3" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "checkbox",
            id: "barcodeSplit",
            onChange: () => this.ocrRadioChange(3),
            checked: this.state.currentIS.ocrMethod === 3
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "barcodeSplit"
          },
          "Smart"
        )))), this.state.doesIronServiceExist && /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            name: "flexRadioDefault",
            id: "ocrRadioIronOCR",
            onChange: () => this.ocrRadioChange(5),
            checked: this.state.currentIS.ocrMethod === 5
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "flexRadioDefault2"
          },
          "OCR 2.0"
        )), /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "form-check form-switch",
            style: { marginTop: "10px" }
          },
          /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              id: "flexSwitchCheckChecked",
              onChange: this.onFastPassChange,
              checked: this.state.currentIS.useFastPass
            }
          ),
          /* @__PURE__ */ React.createElement(
            "label",
            {
              className: "form-check-label",
              htmlFor: "flexSwitchCheckChecked"
            },
            "Use Fast Pass"
          )
        ), /* @__PURE__ */ React.createElement("div", { style: { marginTop: "8px" } }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "checkbox",
            id: "preFlattenFlexSwitchCheckChecked",
            onChange: this.onPreFlattenChange,
            checked: this.state.currentIS.flattenFields
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "preFlattenFlexSwitchCheckChecked"
          },
          "Pre flatten fillable fields"
        ))), /* @__PURE__ */ React.createElement("div", { className: "mb-3", style: { marginTop: "8px" } }, /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-label",
            htmlFor: "flexSwitchCheckChecked"
          },
          "OCR Quality:"
        ), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-control",
            "aria-label": "Select OCR Quality",
            value: this.state.currentIS.ocrQuality,
            onChange: this.onOCRQualityChange
          },
          /* @__PURE__ */ React.createElement("option", { value: "0" }, "Select OCR Quality"),
          /* @__PURE__ */ React.createElement("option", { value: "1" }, "Standard"),
          /* @__PURE__ */ React.createElement("option", { value: "2" }, "High"),
          /* @__PURE__ */ React.createElement("option", { value: "3" }, "Highest"),
          /* @__PURE__ */ React.createElement("option", { value: "4" }, "System Default")
        )))
      )), /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginRight: "10px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Barcodes / Splits / Duplicates"),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "checkbox",
            id: "readBarcodeChange",
            onChange: this.onReadBarcodeChange,
            checked: this.state.currentIS.readBarcode
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "readBarcodeChange"
          },
          "Read Barcodes"
        )), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch ms-3" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "checkbox",
            id: "preSplitChange",
            onChange: this.onEnablePreSplitChange,
            checked: this.state.currentIS.enablePreSplit,
            disabled: this.state.currentIS.readBarcode === false
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "preSplitChange"
          },
          "Enable Barcode Pre-Splits"
        )), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch ms-3" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "checkbox",
            id: "barcodeSplit",
            onChange: this.onEnableBarcodeSplitChange,
            checked: this.state.currentIS.enableBarcodeSplit,
            disabled: this.state.currentIS.readBarcode === false
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "barcodeSplit"
          },
          "Enable Barcode Splits"
        )), this.state.currentIS.enableBarcodeSplit && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "card bcCard",
            style: { marginTop: "10px" }
          },
          /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Splitting barcodes"),
          this.state.currentIS.enableBarcodeSplit && /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("ul", { className: "list-group" }, this.state.currentIS.barCodeSplits.map(
            (bc) => /* @__PURE__ */ React.createElement(
              "li",
              {
                className: "list-group-item d-flex justify-content-between align-items-center",
                key: bc.barCodeId
              },
              /* @__PURE__ */ React.createElement("span", null, bc.barCodeFormula),
              /* @__PURE__ */ React.createElement(
                "span",
                {
                  style: {
                    color: "red",
                    cursor: "pointer"
                  },
                  onClick: () => this.handleDeleteBarcode(
                    bc.barCodeId
                  )
                },
                "x"
              )
            )
          )), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-9" }, /* @__PURE__ */ React.createElement(
            "input",
            {
              type: "text",
              className: "form-control",
              placeholder: "New formula",
              value: this.state.newBarcodeFormula,
              onChange: this.handleBarcodeEdit
            }
          )), /* @__PURE__ */ React.createElement("div", { className: "col-3" }, /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-primary btn-sm",
              onClick: this.handleAddBarcode
            },
            "Add Barcode"
          ))))
        ), /* @__PURE__ */ React.createElement("div", { style: { marginTop: "8px" } }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Dupe Detection:")), /* @__PURE__ */ React.createElement("div", { className: "form-check form-check-inline" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            id: "dupe1",
            value: "reject",
            onChange: this.onChangeDupeDetection,
            checked: this.state.currentIS.dupeDetection === "reject"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "dupe1" }, "Reject")), /* @__PURE__ */ React.createElement("div", { className: "form-check form-check-inline" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            id: "dupe2",
            value: "allow",
            onChange: this.onChangeDupeDetection,
            checked: this.state.currentIS.dupeDetection === "allow"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "dupe2" }, "Allow")), /* @__PURE__ */ React.createElement("div", { className: "form-check form-check-inline" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            id: "dupe3",
            value: "system",
            onChange: this.onChangeDupeDetection,
            checked: this.state.currentIS.dupeDetection === "system"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "dupe3" }, "System Default")))
      ))), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginRight: "10px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Templates / Form recognition"),
        /* @__PURE__ */ React.createElement("div", null),
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("ul", { className: "nav nav-pills card-header-pills" }, /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: `nav-link ${this.state.currentIS.templateStrategy === 0 ? "active" : ""}`,
            onClick: () => this.onTemplateStrategyChange(0)
          },
          "No Template"
        )), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: `nav-link ${this.state.currentIS.templateStrategy === 1 ? "active" : ""}`,
            onClick: () => this.onTemplateStrategyChange(1)
          },
          "One Template"
        )), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: `nav-link ${this.state.currentIS.templateStrategy === 2 ? "active" : ""}`,
            onClick: () => this.onTemplateStrategyChange(2)
          },
          "Smart Template Matching"
        )), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement("div", { className: "ms-2 form-check form-check-inline mt-2" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "checkbox",
            checked: this.state.currentIS.useAIOCR,
            onChange: (e) => this.updateUseAIReader(e)
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Use AI OCR"))), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, this.state.currentIS.useAIOCR === true && /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select form-select mb-3",
            "aria-label": ".form-select example",
            value: this.state.currentIS.autoReaderId,
            onChange: (e) => this.handleAutoReaderChange(e)
          },
          /* @__PURE__ */ React.createElement("option", { value: "-1" }, "Select a reader"),
          this.state.allReaders.map((reader) => /* @__PURE__ */ React.createElement("option", { key: reader.readerId, value: reader.readerId }, reader.name))
        )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("div", { className: "ms-2 form-check form-check-inline mt-2" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "checkbox",
            checked: this.state.currentIS.useDefaults,
            onChange: (e) => this.updateUseDefaults(e)
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Use Defaults"))))),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, this.state.templateError !== "" && /* @__PURE__ */ React.createElement("div", { className: "alert alert-danger" }, this.state.templateError), this.state.currentIS.templateStrategy === 0 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h5", { className: "card-title" }, "Business Process"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select form-select mb-3",
            "aria-label": ".form-select example",
            value: this.state.selectedBPId,
            onChange: this.handleBPSelection
          },
          this.state.bpSelections.map((bp) => /* @__PURE__ */ React.createElement("option", { key: bp.bpId, value: bp.bpId }, bp.display))
        ), /* @__PURE__ */ React.createElement("p", { className: "card-text" }, "No data will be pre-populated.")), this.state.currentIS.templateStrategy === 1 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h5", { className: "card-title" }, "Business Process"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select form-select mb-3",
            "aria-label": ".form-select example",
            value: this.state.selectedBPId,
            onChange: this.handleBPSelection
          },
          this.state.bpSelections.map((bp) => /* @__PURE__ */ React.createElement("option", { key: bp.bpId, value: bp.bpId }, bp.display))
        ), /* @__PURE__ */ React.createElement("h5", { className: "card-title" }, "Template"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select form-select mb-3",
            "aria-label": ".form-select example",
            value: this.state.currentIS.templateId,
            onChange: this.handleTemplateSelection
          },
          /* @__PURE__ */ React.createElement("option", { value: 0 }, "Select a Template"),
          this.state.filteredTemplates.map((tp) => /* @__PURE__ */ React.createElement(
            "option",
            {
              key: tp.templateId,
              value: tp.templateId
            },
            tp.name
          ))
        ), /* @__PURE__ */ React.createElement("p", { className: "card-text" }, "This template will be used every time.")), this.state.currentIS.templateStrategy === 2 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("table", { className: "table" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", { scope: "col" }, "#"), /* @__PURE__ */ React.createElement("th", { scope: "col" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-building" }), " ", "Business Process"), /* @__PURE__ */ React.createElement("th", { scope: "col" }, "Default Template"), /* @__PURE__ */ React.createElement("th", { scope: "col" }))), /* @__PURE__ */ React.createElement("tbody", null, this.state.currentIS.intakeTargets.map(
          (target) => /* @__PURE__ */ React.createElement("tr", { key: target.priority }, /* @__PURE__ */ React.createElement("th", { scope: "row" }, target.priority), target.isEditing && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("td", { colSpan: 1 }, /* @__PURE__ */ React.createElement(
            "select",
            {
              className: "form-select form-select",
              "aria-label": ".form-select example",
              value: target.defaultBpId,
              onChange: (e) => this.handleSelectTarget(
                e,
                target
              )
            },
            this.state.bpSelections.map(
              (bp) => /* @__PURE__ */ React.createElement(
                "option",
                {
                  key: bp.bpId,
                  value: bp.bpId
                },
                bp.display
              )
            )
          )), target.priority === 1 && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
            "select",
            {
              className: "form-select",
              value: target.defaultTemplateId,
              onChange: (e) => this.selectTargetTemplate(
                e,
                target
              )
            },
            /* @__PURE__ */ React.createElement("option", { value: "None" }, "None"),
            target.templates !== void 0 && target.templates.map(
              (template) => /* @__PURE__ */ React.createElement(
                "option",
                {
                  value: template.templateId,
                  key: template.templateId
                },
                template.name
              )
            )
          )), target.priority !== 1 && /* @__PURE__ */ React.createElement("td", null)), !target.isEditing && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("td", null, target.defaultBpName), target.priority === 1 && target.defaultTemplateId !== 0 && /* @__PURE__ */ React.createElement("td", null, target.defaultTemplateName), target.priority === 1 && target.defaultTemplateId === 0 && /* @__PURE__ */ React.createElement("td", null, "No Template"), target.priority !== 1 && /* @__PURE__ */ React.createElement("td", null), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-danger btn-sm",
              style: {
                marginRight: "3px"
              },
              onClick: () => this.onTargetDel(target)
            },
            /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-times"
              }
            )
          ), /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-primary btn-sm",
              onClick: () => this.onTargetEdit(target)
            },
            /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-pencil-alt"
              }
            )
          ), this.state.isRearranging && /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-secondary round-button btn-sm ms-1",
              onClick: () => this.onMoveTargetUp(target)
            },
            /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-arrow-up"
              }
            )
          ), this.state.isRearranging && /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-secondary round-button btn-sm ms-1",
              onClick: () => this.onMoveTargetDown(target)
            },
            /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-arrow-down"
              }
            )
          ))), target.isEditing && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-success btn-sm",
              onClick: () => this.onTargetOk(target)
            },
            "OK"
          )))
        ))), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            onClick: this.onAddTarget
          },
          "Add Business Process"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            style: { marginLeft: "4px" },
            onClick: this.onRearrangeClick
          },
          "Rearrange"
        )))
      ))), this.state.isDirty && /* @__PURE__ */ React.createElement(
        "button",
        {
          style: { marginTop: "8px", padding: "12px" },
          className: "btn btn-success btn-lg",
          onClick: this.onSaveClick
        },
        /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fas fa-save",
            style: { marginRight: "8px" }
          }
        ),
        "   ",
        "Save changes"
      ), /* @__PURE__ */ React.createElement("span", { className: "float-right" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          style: {
            marginTop: "8px",
            padding: "12px",
            marginLeft: "6px"
          },
          className: "btn btn-danger btn-lg float-end",
          onClick: this.startDelete
        },
        /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fas fa-times",
            style: { marginRight: "8px" }
          }
        ),
        "   ",
        "Delete Intake Strategy"
      ), this.state.deleteStatus === 1 && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "alert alert-danger float-end",
          style: { marginTop: "6px" },
          role: "alert"
        },
        /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to delete this intake stategy?"),
        /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            onClick: this.deleteIntakeStrategy
          },
          "Yes - Delete"
        ),
        /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-secondary",
            style: { marginLeft: "6px" },
            onClick: this.cancelDelete
          },
          "Cancel"
        )
      )))
    )), /* @__PURE__ */ React.createElement(
      Link,
      {
        id: "intakeStrategyHomeLink",
        to: "/Admin/IntakeStrategies",
        style: { display: "none" }
      },
      "HiddenLink"
    ));
  }
}
export default IntakeStrategyView;
